var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaxiFrontViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_98_247)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150
  }), /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    rx: 75,
    fill: "#DDB73E",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.542 67.8428C114.151 67.3655 113.563 67.087 112.955 67.087H105.169C103.246 62.0172 100.745 57.0519 97.8993 55.1776C95.4003 53.5369 91.8586 52.3161 87.8008 51.5049V46.0726C87.8008 44.3786 86.4263 43 84.7282 43H65.2685C63.5704 43 62.196 44.3786 62.196 46.0726V51.5049C58.1422 52.3161 54.5964 53.5369 52.1036 55.1776C49.2543 57.054 46.7634 62.0233 44.8297 67.087H37.0459C36.4293 67.087 35.8496 67.3655 35.4584 67.8428C35.0712 68.318 34.9176 68.9448 35.0426 69.5512L36.1978 75.1371C36.3945 76.0896 37.2343 76.7697 38.2032 76.7697H40.5097C38.2831 79.3383 37.2036 82.5748 37.1893 85.8071C37.1749 89.8056 38.6907 93.421 41.4683 95.9774C41.497 96.0019 41.5298 96.0204 41.5585 96.0491V103.866C41.5585 105.56 42.937 106.938 44.6311 106.938H51.8106C53.5088 106.938 54.8832 105.56 54.8832 103.866V100.088L95.1156 100.24V103.868C95.1156 105.564 96.4921 106.94 98.1881 106.94H105.372C107.066 106.94 108.444 105.564 108.444 103.868V96.2006C111.388 93.507 112.797 89.7933 112.814 86.0857C112.826 82.7407 111.697 79.3855 109.34 76.7635H111.8C112.773 76.7635 113.612 76.0835 113.805 75.131L114.958 69.545C115.081 68.9448 114.93 68.3201 114.542 67.8428ZM55.4834 60.3088C59.3671 57.7525 67.0527 56.4681 74.7751 56.4435H75.2319C82.9563 56.4681 90.6378 57.7545 94.5195 60.3088C96.0435 61.3105 98.0038 65.3499 99.8002 70.2988H50.2068C51.9991 65.352 53.9594 61.3126 55.4834 60.3088ZM52.3412 92.6242C49.0003 92.6242 46.2964 89.9182 46.2964 86.5814C46.2964 83.2385 49.0003 80.5366 52.3412 80.5366C55.678 80.5366 58.386 83.2385 58.386 86.5814C58.386 89.9162 55.678 92.6242 52.3412 92.6242ZM97.7457 92.6242C94.4089 92.6242 91.7009 89.9182 91.7009 86.5814C91.7009 83.2385 94.4089 80.5366 97.7457 80.5366C101.087 80.5366 103.79 83.2385 103.79 86.5814C103.79 89.9162 101.083 92.6242 97.7457 92.6242Z",
    fill: "#DDB73E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_98_247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxiFrontViewIcon);
export default __webpack_public_path__ + "static/media/taxi-front-viewIcon.62ab86bc4617023c9d37fdc754614d29.svg";
export { ForwardRef as ReactComponent };